import { render, staticRenderFns } from "./CommentsQuestion.vue?vue&type=template&id=56f95380"
import script from "./CommentsQuestion.vue?vue&type=script&lang=js"
export * from "./CommentsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports